var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.symbol !== _vm.base)?_c('div',{staticClass:"wrapper card"},[_c('div',[_vm._v(_vm._s(Number(_vm.value).toFixed(3))),_c('span',{staticClass:"symbol"},[_vm._v(_vm._s(_vm.symbol))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }